export const AdGroupAudienceCriterion = {
  properties: {
    CriterionType: {
      'bulk-upload-header': 'Type',
      'bulk-upload-mapper': function (value) {
        switch (value) {
          case 'Remessaging':
            return 'Ad Group Remarketing List Association';
          case 'NegativeRemessaging':
            return 'Ad Group Negative Remarketing List Association';
          case 'Custom':
            return 'Ad Group Custom Audience Association';
          case 'NegativeCustom':
            return 'Ad Group Negative Custom Audience Association';
          case 'InMarket':
            return 'Ad Group In Market Audience Association';
          case 'NegativeInMarket':
            return 'Ad Group Negative In Market Audience Association';
          case 'Product':
            return 'Ad Group Product Audience Association';
          case 'NegativeProduct':
            return 'Ad Group Negative Product Audience Association';
          case 'RemarketingSimilar':
            return 'Ad Group Similar Remarketing List Association';
          case 'NegativeRemarketingSimilar':
            return 'Ad Group Negative Similar Remarketing List Association';
          case 'CustomerList':
            return 'Ad Group Customer List Association';
          case 'NegativeCustomerList':
            return 'Ad Group Negative Customer List Association';
          case 'CombinedList':
            return 'Ad Group Combined List Association';
          case 'NegativeCombinedList':
            return 'Ad Group Negative Combined List Association';
          case 'ImpressionBasedRemarketing':
            return 'Ad Group Impression Based Remarketing List Association';
          case 'NegativeImpressionBasedRemarketing':
            return 'Ad Group Negative Impression Based Remarketing List Association';
          case 'CustomSegment':
            return 'Ad Group Custom Segment Association';
          case 'AISegment':
          case 'AIPrompt':
            return 'Ad Group AI Prompt Association';
          default:
            return 'Ad Group Unknown Association';
        }
      },
    },
  },
};
